import { slice } from './slice';

const { reducer } = slice;

export * from './actions';
export * as imageViewerSelectors from './selectors';

export default reducer;
